import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import loadable from "@loadable/component";
const Lottie = loadable(() => import("react-lottie"), {ssr: false});
import { NUMBER } from "../../../constants/app-constants";
import { auctionImpressionLabel, TIMER_LABELS } from "./constant";
import MapView from "./images/map-view.svg";
import Loader from "./lottie-files/loader.json";

const DEFAULT_LOTTIE_OPTIONS = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};

const PostInspectionDiyAuctionImpressions = ({
    auctionTime = "",
    impressionCount = NUMBER.ZERO,
    carSoldCount = NUMBER.ZERO,
    toggleMapHandler = () => {},
    time,
    googlemap = true,
    impressions = [],
    dealerImpressionEnabled = false
}) => {

    const renderTimer = () => {
        return Object.keys(auctionTime).map((key, index) => (
            <p key={`timer-${index}`} styleName={"styles.auctionTime"}>
                <span>{auctionTime[key]}
                    <small>{TIMER_LABELS[index]}</small>
                </span>
            </p>
        ));
    };

    const impressionData = dealerImpressionEnabled ? [impressionCount, carSoldCount] : [carSoldCount];
    return (
        <div styleName={"styles.auctionWrapper"}>
            {time > NUMBER.ZERO && <div>
                <p styleName={"styles.text"}>Live auction ends in</p>
                <div styleName={"styles.auctionTimeWraper"}>
                    {renderTimer()}
                </div>
            </div>}
            {auctionImpressionLabel(dealerImpressionEnabled).map((label, index) => (
                <React.Fragment key={`impression-${index}`}>
                    {
                        !!impressionData[index] &&
                        <div styleName={"styles.auctionTime styles.viewsCar"}>
                            <p>{label}</p>
                            <span>{impressionData[index]}</span>
                        </div>
                    }
                </React.Fragment>
            ))}
            { googlemap && !!parseInt(impressionCount) && impressions && !!impressions.length && <img onClick={toggleMapHandler} src={MapView} alt="map_view" styleName={"styles.viewMap"}/>}
            <div styleName={"styles.timer"}>
                <Lottie options={DEFAULT_LOTTIE_OPTIONS} height={"200px"} width={"200px"} />
            </div>
        </div>
    );
};

PostInspectionDiyAuctionImpressions.propTypes = {
    auctionTime: PropTypes.string,
    impressionCount: PropTypes.number,
    carSoldCount: PropTypes.number,
    toggleMapHandler: PropTypes.func,
    time: PropTypes.any,
    googlemap: PropTypes.bool,
    impressions: PropTypes.array,
    dealerImpressionEnabled: PropTypes.bool
};

export default PostInspectionDiyAuctionImpressions;
